import { Switch } from '@headlessui/react';
import { FaRegLightbulb } from 'react-icons/fa';
import { HiLocationMarker } from 'react-icons/hi';

import { governorates } from '@/lib/helpers';
import CriteriaInput from '@/tayara-kit/CriteriaInput';
import CriteriaSelect from '@/tayara-kit/CriteriaSelect';
import Text from '@/tayara-kit/Text';

const CriteriasStep = ({
  canGoToPrevStep,
  governorate,
  updateGovernorate,
  listDelegation,
  setdelegation,
  delegation,
  phoneNumber,
  setphoneNumber,
  useOwnPhone,
  setUseOnwPhone,
}: any) => (
  <div
    className={` ${canGoToPrevStep ? '' : 'opacity-60  pointer-events-none '}`}
  >
    <>
      {/* forms */}
      <div className="mb-2 md:mb-4">
        <Text
          as="div"
          text="Choisissez l'emplacement de votre annonce *"
          className="text-base lg:text-lg font-semibold text-gray-700 mb-4"
        />
        <div
          className="w-full h-[100px] my-4 relative overflow-hidden rounded-xl
    bg-stone-100 ring-4 ring-gray-500 "
        >
          <img
            src="/media/location.webp"
            alt="tayara position on the map"
            className="contrast-50"
          />
          <div className="absolute inset-0 grid">
            <HiLocationMarker
              size={54}
              className="m-auto text-primary translate-y-[-10%]"
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <CriteriaSelect
            icon={HiLocationMarker}
            onChange={(e) => {
              const selectedValue =
                governorates?.find((c) => c.id === e.target.value) || null;

              updateGovernorate(selectedValue);
            }}
            displayLabel="Ville"
            value={governorate?.id}
            options={governorates?.map(({ id, name, dbvalue }) => ({
              value: id,
              label: name,
              display: dbvalue || name,
            }))}
          ></CriteriaSelect>
          <CriteriaSelect
            icon={HiLocationMarker}
            value={delegation?.id}
            onChange={(e) => {
              const selectedValue =
                listDelegation.find((c: any) => c.id === e.target.value) ||
                null;

              setdelegation(selectedValue);
            }}
            displayLabel="Délégation"
            options={listDelegation?.map(({ id, name }: any) => ({
              value: id,
              label: name,
            }))}
          ></CriteriaSelect>
        </div>
        <div className="flex items-center gap-x-2 my-4">
          <FaRegLightbulb className="text-yellow-400" size={18} />
          <Text
            as="h3"
            text="Dites où vous êtes, indiquez clairement où se trouve votre produit ou service."
            className=" w-5/6 xl:w-full mt-1 text-xs xl:text-base font-light  text-gray-700  "
          />
        </div>
      </div>

      {/* Num tel principal  */}
      <div className="mt-4 space-y-2">
        <Text
          as="div"
          text="Indiquez votre contact *"
          className="text-base lg:text-lg font-semibold text-gray-700 mt-8"
        />
        <div className="w-full py-3 gap-y-2 xl:gap-y-0 flex flex-wrap flex-col xl:flex-row items-start xl:items-start justify-start ">
          <div className="xl:!w-[20rem] flex flex-col xl:flex-row items-center  flex-wrap gap-x-4">
            <Text
              as="div"
              text="Veuillez saisir votre numéro de contact"
              className="text-sm xl:text-base font-semibold text-gray-700 mb-2"
            />
            <CriteriaInput
              type="tel"
              onChange={(e) => setphoneNumber(e.target.value)}
              value={phoneNumber}
              displayLabel="Saisir le numéro de téléphone"
              placeholder="-- --- ---"
              className="!w-fit"
            />
          </div>
          <Text
            as="span"
            text="Ou"
            className=" md:mr-8 xl:mt-[2px] text-xs md:text-sm flex justify-start text-primary font-bold"
          />
          <div className="flex items-center xl:items-start flex-wrap gap-4">
            <Text
              as="div"
              // TODO: Add user default phone number @mehdi
              text="Utiliser votre numéro principal"
              className="text-sm xl:text-base font-semibold text-gray-700 "
            />
            <Switch
              checked={useOwnPhone}
              onChange={setUseOnwPhone}
              className={`${useOwnPhone ? 'bg-primary' : 'bg-gray-300'}
          relative inline-flex flex-shrink-0 h-8 w-16 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
            >
              <span className="sr-only">Use setting</span>
              <span
                aria-hidden="true"
                className={`${useOwnPhone ? 'translate-x-5' : 'translate-x-0'}
                pointer-events-none inline-block h-7 w-8 rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200`}
              />
            </Switch>
          </div>
        </div>
        <div className="flex items-start gap-x-2 my-4">
          <FaRegLightbulb className="text-yellow-400" size={18} />
          <Text
            as="h3"
            text="Restez toujours joignable, un numéro de téléphone valide est essentiel pour faciliter les échanges avec les acheteurs potentiels et renforcer la confiance."
            className=" w-5/6 text-start text-sm font-normal text-gray-600 "
          />
        </div>
        {/* Choix d'affichage le num tel dans l'annonce */}
        {/* <Radio
        srLabel="Choix de visibilité du numéro de téléphone dans l'annonce"
        onChange={() => {}}
        options={[
          { label: "Afficher dans l'annonce" },
          { label: "Masquer dans l'annonce" },
        ]}
      /> */}
      </div>
    </>
  </div>
);

export default CriteriasStep;
